import { render, staticRenderFns } from "./v-field-edit-bool.vue?vue&type=template&id=5c59711c"
import script from "./v-field-edit-bool.vue?vue&type=script&lang=js"
export * from "./v-field-edit-bool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports